// Self-contained data for the Heart & Star Events Place events concept website.
export const BUSINESS = {
  "slug": "heart-star-events-place-concept",
  "media": {
    "hero": "/events/heart-star/01.jpg",
    "logo": "/events/heart-star/13.jpg",
    "gallery": [
      "/events/heart-star/02.jpg",
      "/events/heart-star/03.jpg",
      "/events/heart-star/04.jpg",
      "/events/heart-star/05.jpg",
      "/events/heart-star/06.jpg",
      "/events/heart-star/07.jpg",
      "/events/heart-star/08.jpg",
      "/events/heart-star/09.jpg",
      "/events/heart-star/10.jpg",
      "/events/heart-star/11.jpg",
      "/events/heart-star/12.jpg"
    ]
  },
  "name": "Heart & Star Events Place",
  "shortName": "Heart & Star",
  "kind": "venue",
  "layout": "outdoor",
  "location": "Bacolod City",
  "address": "Punta Taytay Road / Kaingin 1 area, Bacolod City, Negros Occidental, Philippines",
  "eyebrow": "Poolside celebrations in Bacolod",
  "headline": "A private place to gather, swim and celebrate together.",
  "intro": "A bright, relaxed venue centered on the pool, outdoor space and the family occasions welcomed here.",
  "venueFeature": "Pool & outdoor space",
  "services": [
    "Birthdays",
    "Baptisms and dedications",
    "Reunions",
    "Retreats",
    "Team building",
    "Family days",
    "Wedding receptions",
    "Private celebrations"
  ],
  "proof": [
    "Pool is a central promoted feature",
    "Family-oriented event range",
    "Active public event presence in 2026"
  ],
  "reviewSnapshot": "Public rating last checked in August 2026: about 4.8/5 from 8 reviews. Individual review text was not available.",
  "reviews": [],
  "contact": {
    "phone": "+63 917 114 6180",
    "phoneHref": "+639171146180",
    "facebook": "https://www.facebook.com/100064719134144/"
  },
  "sources": [
    "https://www.facebook.com/100064719134144/",
    "https://www.facebook.com/100064719134144/videos/8848223461909501/"
  ]
};
